import { Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Box, CircularProgress } from "@mui/material";
import { NotFound } from "../../pages/NotFound";

export default function AdminRoute() {
  const { user, isAdmin, loading, profileLoading } = useAuth();

  if (loading || (user && profileLoading)) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user || !isAdmin) {
    return <NotFound />;
  }

  return <Outlet />;
}
